import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, DELETE } from "const"
import { MtStudySession } from "server/models"
import {
    PRM_STUDY_SESSION,
    StoreType,
    addModal,
} from "client/store"
import { hasProjectAccess } from "client/utils"
import {
    Link,
    DateFormatter,
    TableColumn,
    Empty,
} from "client/components"

const Columns = () => {
    const baseRoute = useSelector((state: StoreType) => state.studySession.baseRoute)
    const studyList = useSelector((state: StoreType) => state.study.studyList)
    const teamMemberList = useSelector((state: StoreType) => state.studyTeamMember.teamMemberList)

    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const deleteAccess = hasProjectAccess(PRM_STUDY_SESSION, DELETE)

    const { sessionFields } = projectSettings.study.sessionFieldsAssigned ? projectSettings.study : accountSettings.study

    const sessionLink = (session: MtStudySession, linkContent: any) => {
        const href = `${baseRoute}/${VIEW}/${session.id}`
        return (
            <Link
                href={href}
                onClick={() => dispatch(addModal({ url: href }))}
            >
                {linkContent}
            </Link>
        )
    }

    const columns: TableColumn[] = [
        {
            field: "date",
            header: lang.date,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (session: MtStudySession) => sessionLink(session, <DateFormatter date={session.date} showTime={false} />),
        },
        {
            field: "startTime",
            header: lang.startTime,
            sortable: true,
            cellMinWidth: "120px",
        },
        {
            field: "endTime",
            header: lang.endTime,
            sortable: true,
            cellMinWidth: "120px",
        },
        {
            field: "studyId",
            header: lang.study,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (session: MtStudySession) => {
                const study = studyList[session.studyId]
                return study ? study.name : <Empty />
            },
        },
        {
            field: "facilitatorId",
            header: lang.facilitator,
            display: sessionFields.facilitator,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (session: MtStudySession) => {
                const facilitator = teamMemberList[session.facilitatorId]
                return facilitator ? facilitator.name : <Empty />
            },
        },
        {
            field: "scribeId",
            header: lang.scribe,
            display: sessionFields.scribe,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (session: MtStudySession) => {
                const scribe = teamMemberList[session.scribeId]
                return scribe ? scribe.name : <Empty />
            },
        },
        {
            field: "comment",
            header: lang.comment,
            display: sessionFields.comment,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "200px",
            formatter: (session: MtStudySession) => <DateFormatter date={session.createdAt} />,
        },
    ]

    if (deleteAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
